enum MenuEnum {
  SWITCH_ORGANIZATION = 'Trocar instituição',
  LOGOUT = 'Sair'
}

export default MenuEnum
